import PropTypes from 'prop-types';
import React from 'react';
import DrawerLayout from '../../../Layout/DrawerLayout/DrawerLayout';
import Menu from '../../../Modules/Menu/Menu';
import { pageDisplayModePropTypes } from '../../../../../../pages/defaultProps';
import { PAGE_DISPLAY_MODE } from '../../../../../../pages/constants';

import './UserDrawer.scss';

export default class UserDrawer extends React.PureComponent {
    static propTypes = {
        /**
         * Whether the drawer is open
         */
        isDrawerOpen: PropTypes.bool.isRequired,
        /**
         * handler for closing
         */
        handleClose: PropTypes.func.isRequired,
        /**
         * text to be display on topbar
         */
        headerText: PropTypes.string.isRequired,
        /**
         * position of the drawer
         */
        direction: PropTypes.string.isRequired,
        /**
         * list of items to be displayed in user menu
         */
        menuItems: PropTypes.array.isRequired,
        /**
         * style to override default
         */
        className: PropTypes.string,
        /**
         * Value of the view layout the page is in
         */
        pageDisplayMode: pageDisplayModePropTypes.isRequired,
    };

    static defaultProps = {
        isDrawerOpen: false,
        handleClose: () => {},
        menuItems: [],
        headerText: '',
        className: '',
    };

    render() {
        const {
            profileImage,
            headerText,
            handleClose,
            isDrawerOpen,
            direction,
            menuItems,
            className,
            pageDisplayMode,
        } = this.props;
        const employerLayoutClassName =
            pageDisplayMode === PAGE_DISPLAY_MODE.EMPLOYER_DEFAULT
                ? 'employer-layout-nav'
                : '';

        return (
            <DrawerLayout
                cssClass={`component-Layout-Header-Modules-Drawers-UserDrawer ${employerLayoutClassName} ${className}`}
                profileImage={profileImage}
                headerText={headerText}
                isDrawerOpen={isDrawerOpen}
                handleClose={handleClose}
                direction={direction}
            >
                <Menu menuItems={menuItems} cssClass="user-drawer-menu" />
            </DrawerLayout>
        );
    }
}
